import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FamilyCtx = createContext(null);

export const FamilyProvider = ({ children }) => {
  const { user } = useAuth();
  const [members, setMembers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    if (!user) { setMembers([]); setSelected(null); return; }
    setLoading(true);
    try {
      const res = await api.get("/family");
      setMembers(res.data);
      const savedId = localStorage.getItem("ibloom_family_id");
      const pick = res.data.find((m) => m.id === savedId) || res.data[0] || null;
      setSelected(pick);
      if (pick) localStorage.setItem("ibloom_family_id", pick.id);
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { reload(); }, [reload]);

  const selectMember = (m) => {
    setSelected(m);
    if (m) localStorage.setItem("ibloom_family_id", m.id);
  };

  return (
    <FamilyCtx.Provider value={{ members, selected, selectMember, reload, loading }}>
      {children}
    </FamilyCtx.Provider>
  );
};

export const useFamily = () => useContext(FamilyCtx);
